<div class="crop-health-map-controls">
  <ul>
    <li (click)="onZoomClick.emit('plus')">
      <div class="btn">
        <!-- <dk-plus-black-icon /> -->
        <i class="ph-bold ph-plus"></i>
      </div>
    </li>
    <li (click)="onZoomClick.emit('minus')">
      <div class="btn">
        <!-- <dk-minus-icon /> -->
        <i class="ph-bold ph-minus"></i>
      </div>
    </li>
  </ul>
</div>
